import { useState, useEffect, useCallback } from 'react';

export const useCheckbox = ({ checked, onChange }) => {
  const [_checked, setChecked] = useState(checked || false);

  useEffect(() => {
    if (checked !== undefined && checked !== _checked) {
      setChecked(checked);
    }
  }, [_checked, checked]);

  const handleChange = useCallback(
    e => {
      if (checked === undefined) {
        setChecked(e.target.checked);
      }
      if (typeof onChange === 'function') {
        onChange({
          target: e.target,
          stopPropagation() {
            e.stopPropagation();
          },
          preventDefault() {
            e.preventDefault();
          },
          nativeEvent: e.nativeEvent,
        });
      }
    },
    [checked, onChange]
  );
  return {
    isChecked: _checked,
    handleChange,
  };
};
